import type { DailyTacticalReadiness } from '../../services/operationsApi';
import { blockerInfo } from './fableLabels';

/** 공식 시작을 막는 조건을 쉬운 말로 번역해 보여주는 패널. */
export default function FableBlockers({ readiness }: Props) {
  const blockers = readiness.blockers;
  const rows = blockers.map((code) => ({ code, info: blockerInfo(code) }));
  const actionRequired = rows.filter(({ info }) => info.tone !== 'info');
  const changesOnStart = rows.filter(({ info }) => info.tone === 'info');
  const deadline = readiness.deadline_audit;
  return (
    <section className="fable-panel">
      <header className="fable-panel-head">
        <h3>다음 단계로 넘어가기 전 남은 일</h3>
        <p>
          지금 고쳐야 할 문제 {actionRequired.length}건 · 시작 승인 시 바뀌는 설정 {changesOnStart.length}건
        </p>
      </header>
      {blockers.length === 0 ? (
        <p className="fable-empty">남은 조건이 없습니다.</p>
      ) : (
        <ul className="fable-blocker-list">
          {rows.map(({ code, info }) => {
            return (
              <li key={code} className={`fable-blocker tone-${info.tone}`}>
                <div>
                  <strong>{info.title}</strong>
                  <span className={`fable-condition-kind ${info.tone === 'info' ? 'expected' : 'action'}`}>
                    {info.tone === 'info' ? '시작할 때 변경' : '확인 필요'}
                  </span>
                </div>
                <p>{info.detail}</p>
              </li>
            );
          })}
        </ul>
      )}
      {blockers.length > 0 && (
        <details className="fable-tech-ref">
          <summary>기술 식별자 보기</summary>
          <p>{blockers.map((code) => <code key={code}>{code}</code>)}</p>
        </details>
      )}
      <div className="fable-deadline">
        <strong>정해진 시간 안에 판단했는지</strong>
        {deadline ? (
          <p>
            최근 {deadline.checked_run_count}건 점검, 마감 위반 {deadline.late_deviation_count}건
            {deadline.late_deviation_count > 0 && ` (위반 기록: ${deadline.late_run_ids.join(', ')})`}
            . 판단이 정해진 시간보다 늦게 저장되면 위반으로 기록합니다.
          </p>
        ) : (
          <p>데이터 없음</p>
        )}
        <ModelAudit readiness={readiness} />
      </div>
    </section>
  );
}

function ModelAudit({ readiness }: Props) {
  const m = readiness.model_audit;
  return (
    <p className="fable-model-audit">
      최근 사용한 AI 모델:{' '}
      <strong>{m.latest_recorded_model_name || '데이터 없음'}</strong>
      {m.uses_fallback_model_name && ' (임시 이름 — 실제 모델 아님)'}
      {' · '}같은 조건에서 답변 차이를 줄이는 설정: {m.temperature_zero_configured ? '적용됨' : '미적용'}
    </p>
  );
}

type Props = { readiness: DailyTacticalReadiness };
